import Market from '@root/core/src/models/market';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import { Colors, StyleSheet } from '@root/core/src/utils/styles';
import { P2 } from '@root/gatsby-contentful-core/src/components/text';
import { toRgba } from '@root/gatsby-contentful-core/src/utils/colors';

const MapTooltip = React.forwardRef(({
  tooltipData, tooltipPosition, startDate,
}, ref) => {
  const formattedStartDate = new Date(startDate).toLocaleString('en-us', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  if (tooltipData) {
    const overallDirectionChange = tooltipData['2020'].pctChange < 0 ? 'decrease' : 'increase';

    return (
      <div
        css={styles.tooltipContainer}
        ref={ref}
        style={{
          left: `${tooltipPosition.left}px`,
          top: `${tooltipPosition.top}px`,
        }}
      >
        <P2 css={styles.tooltipTitle}>{`${Market.MAPPING[tooltipData.state]}: ${Math.abs(tooltipData['2020'].pctChange)}% ${overallDirectionChange}`}</P2>
        {tooltipData.metroAreas &&
          <ul css={styles.metroAreaList}>
            {
              Object.keys(tooltipData.metroAreas).map((metroArea, index) => {
                const metroAreaDirectionChange = tooltipData.metroAreas[metroArea]['2020'].pctChange < 0 ? 'decrease' : 'increase';
                return (
                  <li
                    css={styles.metroAreaItem}
                    key={index}
                  >
                    <span css={styles.metroArea}>{metroArea.toLowerCase().replace(/-/gi, ' - ')}</span>: {Math.abs(tooltipData.metroAreas[metroArea]['2020'].pctChange)}% {metroAreaDirectionChange}
                  </li>
                );
              })
            }
          </ul>
        }
        <P2 css={styles.startDate}>{`Since ${formattedStartDate}`}</P2>
      </div>
    );
  }

  return null;
});

MapTooltip.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  tooltipData: PropTypes.shape({
    2019: PropTypes.object,
    2020: PropTypes.object,
    metroAreas: PropTypes.object,
    state: PropTypes.string,
  }),
  tooltipPosition: PropTypes.object,
};

const styles = StyleSheet.create({
  tooltipContainer: {
    display: 'block',
    maxWidth: 640,
    width: '100%',
    padding: '24px 6px',
    margin: 'auto',
    background: Colors.white(),
    textAlign: 'left',
    ...Responsive.md({
      position: 'absolute',
      minWidth: 180,
      maxWidth: 'none',
      width: 'auto',
      padding: '14px 22px',
      border: `1px solid ${Colors.gray40()}`,
      borderRadius: 6,
      boxShadow: `0 6px 20px -4px ${toRgba(Colors.black(), 0.25)}`,
      lineHeight: '120%',
      zIndex: 1,
    }),
  },
  tooltipTitle: {
    fontSize: 22,
    color: Colors.nearBlack(),
    marginBottom: 5,
    fontWeight: 600,
    ...Responsive.md({
      fontSize: 12,
    }),
  },
  metroAreaList: {
    listStyle: 'none',
    marginBottom: 3,
  },
  metroAreaItem: {
    margin: 0,
    padding: '9px 0',
    borderBottom: `1px solid ${Colors.gray20()}`,
    color: Colors.gray50(),
    fontSize: 18,
    ...Responsive.md({
      fontSize: 12,
      padding: '3px 0',
    }),
  },
  metroArea: {
    textTransform: 'capitalize',
  },
  startDate: {
    fontSize: 14,
    paddingTop: 9,
    ...Responsive.md({
      fontSize: 12,
      fontWeight: 600,
      padding: 0,
    }),
  },
});

export default MapTooltip;
